import { COLORS, FONTS } from '../../constants';

const styles = theme => ({
  root: {
    backgroundColor: '#333333',
    zIndex: 1,
    height: '100vh',
  },
  container: {
    // backgroundColor: '#333333',
    backgroundColor: COLORS.WHITE,
    display: 'flex',
    minHeight: '100%',
  },
  footer: {
    width: 'auto',
  },
  loginLeftPanel: {
    flex: '8 1 auto',
    backgroundSize: 'cover',
    justifyContent: 'center',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',

    // [theme.breakpoints.up('lg')]: {
    //   backgroundSize: '100% 100%',
    // },
    // '& h1': {
    //   fontFamily: FONTS.THIRD,
    //   color: COLORS.GREY_DARK,
    //   textAlign: 'center',
    //   marginTop: 80,
    //   fontSize: '6.375rem',
    //   fontWeight: 300,
    // },
    '& div': {
      // position: 'absolute',
      fontFamily: FONTS.THIRD,
      color: COLORS.GREY_DARK,
      textAlign: 'left',
      marginTop: 130,
      // margin: 'auto',
      // top: 100,
      // width: '100%',
    },
  },
  whiteBox: {
    backgroundColor: 'white',
    maxWidth: '600px',
    // maxWidth: '490px',
    margin: 'auto',
    padding: '45px',
    textAlign: 'left',
    opacity: 0.9,
  },
  textContent: {
    fontSize: '16px',
    fontWeight: 400,
    color: COLORS.GREY_DARK,
    marginBottom: 22,
    fontFamily: FONTS.PRIMARY,
  },
  headerContent: {
    fontFamily: FONTS.SECONDARY,
    fontSize: '36px',
    fontWeight: 600,
    color: COLORS.GREY_DARK,
    marginBottom: 25,
    '& span': {
      color: COLORS.GREEN_0,
    },
  },
  loginRightPanel: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
    position: 'relative',
    margin: '100px 5% 25px',
    [theme.breakpoints.up('md')]: {
      marginTop: 200,
    },
  },
  loginItemsContain: {
    width: '100%',
    zIndex: 3,
  },
  form: {
    width: '100%',
    marginTop: 40,
  },
  JhIconContain: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    color: 'white',
    fontSize: '24px',
    fontWeight: 'bold',
    flex: '1',
    textAlign: 'left',
    fontFamily: 'Arial',
    '& > svg': {
      width: '200px',
      fill: 'white',
    },
  },
  JhIcon: {},
  icon: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    zIndex: 2,
  },
  number: {
    color: '#00672d',
    fontWeight: 600,
  },
  newPwSuccessText: {
    paddingBottom: '10px',
    color: 'black',
  },
  signUpButtonContainer: {
    width: '100%',
    marginTop: 50,
    marginBottom: 25,
    [theme.breakpoints.up('md')]: {
      marginTop: 100,
    },
  },
  signUpButton: {
    // borderColor: COLORS.WHITE,
    // color: COLORS.WHITE,
    width: '100%',
    fontSize: 17,
    fontWeight: 600,
    borderColor: '#343B4D',
    borderWidth: '2px',
    color: COLORS.PURPLE,
    backgroundColor: 'COLORS.WHITE',
    marginTop: 15,
    height: '61px',
  },
  troubleLoginText: {
    color: COLORS.GREY_DARK,
  },
});

export default styles;
